module.exports = __webpack_public_path__ + "media/images/photo-event-f800f1f88d210b5037fcd48ef8850f8a.jpg";